<template>
  <header class="header">
    <img alt="Vue logo" height="50" class="white-logo" src="../../assets/logo.png">
  </header>
  <div class="row">
  <div class="col-12 col-md-4 offset-md-4 mt-5 container">

  <div class="card">
    <div v-if="loading" class="text-center pt-4 pb-4">
      <img  src="../../assets/loaderPrimary.svg" height="50" alt="">
    </div>
    <div v-if="!loading" class="card-body">
      <div class="text-center mb-4 mt-1">
        <v-icon :name="iconName" scale="2" :fill="fillColor" />
      </div>
      <div>
        <h4 class="text-center mb-4 mt-1"> {{ title }}</h4>
        <p class="text-center mb-4 mt-1"> {{ message }}</p>
        
        <!-- ✅ CRÍTICO: Mostrar countdown SOLO si callback fue exitoso -->
        <div v-if="redirectUrl && redirectCountdown > 0 && iconName === 'bi-check-circle'" class="text-center mt-3">
          <div class="progress mb-2" style="height: 6px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
                 :style="`width: ${(5 - redirectCountdown) * 20}%`">
            </div>
          </div>
          <small class="text-success">
            <i class="bi bi-arrow-return-left"></i>
            Redirigiendo automáticamente en {{ redirectCountdown }} segundos...
          </small>
        </div>
        
        <!-- ✅ CRÍTICO: Botón manual SIEMPRE disponible cuando hay redirectUrl -->
        <div v-if="redirectUrl" class="text-center mt-4">
          <button 
            @click="redirectToOriginalPage"
            class="btn"
            :class="iconName === 'bi-check-circle' ? 'btn-success' : 'btn-warning'"
            style="padding: 12px 24px; font-weight: bold;">
            <i class="bi bi-arrow-return-left me-2"></i>
            {{ 
              iconName === 'bi-check-circle' ? 'Continuar con mi contrato' : 
              title === 'Proceso cancelado' ? 'Volver a mi contrato' : 
              'Volver para reintentar' 
            }}
          </button>
          

          <div class="mt-2">
            <small v-if="iconName === 'bi-check-circle'" class="text-success">
               El proceso se completó correctamente
            </small>
            <small v-else-if="title === 'Proceso cancelado'" class="text-info">
              ℹPuedes reanudar tu proceso cuando quieras
            </small>
            <small v-else class="text-warning">
              Usa este botón para volver al proceso
            </small>
          </div>
        </div>
        
        <!-- ✅ CRÍTICO: Información adicional si no hay redirectUrl -->
        <div v-if="!redirectUrl && !loading" class="text-center mt-4">
          <div class="alert alert-warning">
            <i class="bi bi-exclamation-triangle me-2"></i>
            <strong>Sin datos de sesión</strong><br>
            No se pudieron recuperar los datos para volver automáticamente.
          </div>
          <button 
            @click="goToDefaultPage"
            class="btn btn-outline-primary">
            <i class="bi bi-house me-2"></i>
            Ir a página principal
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';



export default {
  name: 'FeedBackBr',

  data() {
    return {
      title: '',
      message: '',
      iconName: '',
      income_check_id: '',
      reports_generation_job_id: '',
      state: '',
      url: '',
      loading: true,

      sessionData: null,
      redirectUrl: null,
      redirectCountdown: 5,
      countdownInterval: null
    }
  },
  computed: {
    fillColor() {
      return this.iconName === 'hi-x-circle' ? 'red' : 'green'
    }
  },
  mounted() {
    console.log('🔄 [CALLBACK] Iniciando proceso de callback...');
    console.log('📍 [DEBUG] URL actual:', window.location.href);
    console.log('📍 [DEBUG] Query params:', this.$route.query);
    console.log('📍 [DEBUG] Hostname:', window.location.hostname);
    
    // ✅ NUEVO: Detectar el método de recuperación disponible
    const hasUrlParams = this.$route.query.session_contract_id && this.$route.query.session_access_key;
    const hasCrossBrowserFlag = this.$route.query.cross_browser_fallback;
    
    console.log('🔍 [DEBUG] Parámetros disponibles:', {
      hasUrlParams,
      hasCrossBrowserFlag,
      session_contract_id: this.$route.query.session_contract_id,
      session_access_key: this.$route.query.session_access_key ? 'PRESENTE' : 'AUSENTE'
    });
    
    // ✅ PRIORIDAD 1: Usar URL parameters (más confiable cross-domain)
    if (hasUrlParams) {
      console.log('✅ [URL-PARAMS] Usando datos desde URL parameters...');
      this.sessionData = this.getBankReaderDataFromUrl();
      console.log('📦 [URL-PARAMS] Datos recuperados:', this.sessionData);
    } 
    // ✅ PRIORIDAD 2: Intentar sessionStorage solo si estamos en mismo dominio
    else {
      console.log('🔄 [SESSION] Intentando sessionStorage...');
      this.sessionData = this.getBankReaderSessionData();
      console.log('📦 [SESSION] Datos de sesión recuperados:', this.sessionData);
      
      // ✅ PRIORIDAD 3: Fallback a URL si sessionStorage falla
      if (!this.sessionData) {
        console.log('⚠️ [FALLBACK] SessionStorage falló, intentando URL...');
        this.sessionData = this.getBankReaderDataFromUrl();
        console.log('🌐 [FALLBACK] Datos desde URL recuperados:', this.sessionData);
      }
    }
    
    // ✅ PRIORIDAD 4: Si todavía no hay datos, intentar extraer contractId del external_reference
    if (!this.sessionData) {
      console.log('🔍 [ULTIMO-INTENTO] Intentando extraer contractId de otros parámetros...');
      const extractedContractId = this.extractContractIdFromCallback();
      if (extractedContractId) {
        console.log('✅ [ULTIMO-INTENTO] ContractId extraído:', extractedContractId);
        // Crear un sessionData mínimo para poder continuar
        this.sessionData = {
          contractId: extractedContractId,
          accessKey: 'RECOVERED_FROM_CALLBACK', // AccessKey no disponible en este caso
          originalUrl: this.getDefaultReturnUrl() + '?contractId=' + extractedContractId,
          timestamp: new Date().getTime(),
          isValid: true,
          source: 'extracted_from_callback'
        };
      }
    }
    
    // Procesar según el tipo de callback
    if (this.$route.query.error) {
      console.log('❌ [ERROR] Error detectado en URL');
      
      const errorType = this.$route.query.error;
      const errorReason = this.$route.query.error_reason;
      const errorMessage = this.$route.query.message;
      
      console.log('📋 [ERROR] Detalles:', { errorType, errorReason, errorMessage });
      this.handleBankReaderError(errorType, errorReason, errorMessage);
    }
    else if(this.$route.query.income_check_id || this.$route.query.reports_generation_job_id) {
      console.log('✅ [CALLBACK] Parámetros de callback detectados, ejecutando...');
      this.income_check_id = this.$route.query.income_check_id
      this.reports_generation_job_id = this.$route.query.reports_generation_job_id
      this.state = this.$route.query.state
      
      console.log('📋 [CALLBACK] IDs:', {
        income_check_id: this.income_check_id,
        reports_generation_job_id: this.reports_generation_job_id
      });
      
      this.getFeedbackCall()
    } else {
      console.warn('⚠️ [CALLBACK] No se detectaron parámetros de callback válidos');
      console.log('📋 [DEBUG] Verificando si tenemos sessionData para generar URL manual...');
      
      this.loading = false;
      this.title = 'Información insuficiente'
      this.message = 'No se encontraron datos válidos para procesar el callback.'
      this.iconName = 'hi-x-circle'
      this.showManualRedirectOption();
    }
  },
  
  beforeUnmount() {
    console.log('Limpiando componente...');
    this.cancelRedirectCountdown();
  },
  methods: {
    getUrlToCall() {
      if(this.income_check_id) {
        this.url = '/bankreader/callback'+ '?income_check_id=' + this.income_check_id
      } else if(this.reports_generation_job_id) {
        this.url = '/bankreader/callback'+ '?reports_generation_job_id=' + this.reports_generation_job_id
      }
      if(this.state) {
        this.url += '&state=' + this.state
      }
      return this.url
    },
    getFeedbackCall() {
      console.log('Iniciando llamada al servidor...', this.url);
      
      this.getUrlToCall()
      axios.get(this.url)
      .then((response) => {
        console.log('Respuesta exitosa del servidor:', response)
        
        if (response.status === 200 && response.data) {
          console.log('Callback procesado exitosamente por el servidor');
          
        this.loading = false
          this.title = '¡Proceso completado con éxito!'
          this.message = 'Hemos recibido tu información correctamente y el contrato puede continuar.'
          this.iconName = 'bi-check-circle'
          
          this.generateReturnUrlForSuccess();
          this.showSuccessWithRedirect();
          
        } else {
          console.warn('Respuesta del servidor no válida:', response);
          this.handleCallbackFailure('Respuesta del servidor no válida');
        }
      })
      .catch((error) => {
          console.error('Error en callback:', error)
          this.handleCallbackFailure('Error de conexión con el servidor');
        }
      )
    },

    handleCallbackFailure(reason) {
      this.loading = false
      this.title = 'No se pudo completar el proceso'
      this.message = `${reason}. Es importante que completes este paso para continuar con tu contrato.`
      this.iconName = 'hi-x-circle'
      
      this.generateReturnUrlForError();
      this.showManualRedirectOption();
    },

    showSuccessWithRedirect() {
      console.log('Mostrando éxito con redirección automática');
      
      this.message += ' Te redirigiremos automáticamente para continuar.';
      
      setTimeout(() => {
        this.startRedirectCountdown();
      }, 2000);
    },

    showManualRedirectOption() {
      console.log('Mostrando opción de redirección manual');
      
      this.message += ' Puedes volver manualmente al proceso para continuar.';
      
      this.redirectCountdown = 0;
    },

    getBankReaderSessionData() {
      console.log('🔍 [SESSION] Recuperando datos de sessionStorage...');
      console.log('🔍 [SESSION] Dominio actual:', window.location.hostname);
      console.log('🔍 [SESSION] URL completa:', window.location.href);
      
      try {
        const storage = sessionStorage;
        const keyPrefix = 'rentik_bankreader_';
        
        // ✅ DEBUG: Mostrar todas las claves de sessionStorage
        console.log('🔍 [SESSION] Total claves en sessionStorage:', storage.length);
        const allKeys = [];
        for (let i = 0; i < storage.length; i++) {
          allKeys.push(storage.key(i));
        }
        console.log('🔍 [SESSION] Todas las claves:', allKeys);
        console.log('🔍 [SESSION] Claves de Bank Reader:', allKeys.filter(key => key && key.includes('rentik_bankreader')));
        
        const contractIdFromCallback = this.extractContractIdFromCallback();
        
        if (!contractIdFromCallback) {
          console.warn('⚠️ [SESSION] No se pudo determinar contractId desde callback');
          return null;
        }
        
        console.log('✅ [SESSION] ContractId para buscar:', contractIdFromCallback);
        
        const uniqueKeyPrefix = `${keyPrefix}${contractIdFromCallback}_`;
        console.log('🔍 [SESSION] Buscando con prefijo:', uniqueKeyPrefix);
        
        const contractId = storage.getItem(uniqueKeyPrefix + 'contractId');
        const accessKey = storage.getItem(uniqueKeyPrefix + 'accessKey');
        const originalUrl = storage.getItem(uniqueKeyPrefix + 'originalUrl');
        const timestamp = storage.getItem(uniqueKeyPrefix + 'timestamp');
        
        console.log('🔍 [SESSION] Datos encontrados:', {
          contractId: contractId,
          accessKey: accessKey ? accessKey.substring(0, 8) + '...' : null,
          originalUrl: originalUrl,
          timestamp: timestamp,
          keys_searched: [
            uniqueKeyPrefix + 'contractId',
            uniqueKeyPrefix + 'accessKey',
            uniqueKeyPrefix + 'originalUrl', 
            uniqueKeyPrefix + 'timestamp'
          ]
        });
        
        if (!contractId || !accessKey || !originalUrl || !timestamp) {
          console.warn('⚠️ [SESSION] Datos incompletos encontrados en sessionStorage');
          console.log('❌ [SESSION] Razón del fallo: Dominio diferente (www.rentik.com vs distribuidor.rentik.com)');
          return null;
        }
        
        const now = new Date().getTime();
        const savedTime = parseInt(timestamp);
        const ttlMs = 2 * 60 * 60 * 1000;
        
        if ((now - savedTime) > ttlMs) {
          console.warn('Datos expirados');
          return null;
        }
        
        return {
          contractId: contractId,
          accessKey: accessKey,
          originalUrl: originalUrl,
          timestamp: savedTime,
          isValid: true
        };
        
      } catch (error) {
        console.error('Error recuperando datos:', error);
        return null;
      }
    },

    getBankReaderDataFromUrl() {
      console.log('Extrayendo datos de Bank Reader desde parámetros URL...');
      
      try {
        const urlParams = new URLSearchParams(window.location.search);
        
        const contractId = urlParams.get('session_contract_id');
        const accessKey = urlParams.get('session_access_key');
        const crossBrowserFallback = urlParams.get('cross_browser_fallback');
        
        console.log('🔍 [URL-EXTRACT] Parámetros encontrados:', {
          contractId: contractId,
          accessKey: accessKey ? accessKey.substring(0, 8) + '...' : null,
          crossBrowserFallback: crossBrowserFallback
        });
        
        // ✅ REQUERIMIENTO MÍNIMO: Solo contractId y accessKey
        if (!contractId || !accessKey) {
          console.warn('⚠️ [URL-EXTRACT] Parámetros mínimos insuficientes:', { contractId, accessKey });
          return null;
        }
        
        console.log('✅ [URL-EXTRACT] Datos mínimos válidos encontrados');
        
                const baseUrl = this.getDefaultReturnUrl();
        const originalUrl = `${baseUrl}?contractId=${contractId}&accessKey=${encodeURIComponent(accessKey)}`;

        return {
          contractId: contractId,
          accessKey: accessKey,
          originalUrl: originalUrl,
          timestamp: new Date().getTime(),
          isValid: true,
          source: 'url_fallback'
        };
        
      } catch (error) {
        console.error('Error extrayendo datos desde URL:', error);
        return null;
      }
    },

    generateReturnUrlForSuccess() {
      if (!this.sessionData) {
        console.warn('No hay datos de sesión para generar URL');
        this.redirectUrl = this.getDefaultReturnUrl();
        return;
      }
      
      try {
        const originalUrl = new URL(this.sessionData.originalUrl);
        const baseUrl = originalUrl.origin + originalUrl.pathname;
        
        const returnUrl = new URL(baseUrl);
        returnUrl.searchParams.set('contractId', this.sessionData.contractId);
        
        // Solo agregar accessKey si tenemos uno válido
        if (this.sessionData.accessKey && this.sessionData.accessKey !== 'RECOVERED_FROM_CALLBACK') {
          returnUrl.searchParams.set('accessKey', this.sessionData.accessKey);
        }
        
        returnUrl.searchParams.set('bank_reader_status', 'completed');
        
        this.redirectUrl = returnUrl.toString();
        console.log('URL de retorno exitosa generada:', this.redirectUrl);
        
      } catch (error) {
        console.error('Error generando URL exitosa:', error);
        this.redirectUrl = this.sessionData.originalUrl;
      }
    },

    generateReturnUrlForError() {
      if (!this.sessionData) {
        console.warn('No hay datos de sesión para generar URL de error');
        this.redirectUrl = this.getDefaultReturnUrl();
        return;
      }
      
      try {
        const originalUrl = new URL(this.sessionData.originalUrl);
        const baseUrl = originalUrl.origin + originalUrl.pathname;
        
        const returnUrl = new URL(baseUrl);
        returnUrl.searchParams.set('contractId', this.sessionData.contractId);
        
        // Solo agregar accessKey si tenemos uno válido
        if (this.sessionData.accessKey && this.sessionData.accessKey !== 'RECOVERED_FROM_CALLBACK') {
          returnUrl.searchParams.set('accessKey', this.sessionData.accessKey);
        }
        
        returnUrl.searchParams.set('bank_reader_status', 'retry');
        
        this.redirectUrl = returnUrl.toString();
        console.log('🔗 [VUE-URL] URL de retorno con error generada:', this.redirectUrl);
        
      } catch (error) {
        console.error('Error generando URL de error:', error);
        this.redirectUrl = this.sessionData.originalUrl;
      }
    },

    startRedirectCountdown() {
      console.log('Iniciando countdown de redirección automática');
      
      if (this.iconName !== 'bi-check-circle') {
        console.warn('Countdown cancelado - callback no fue exitoso');
        return;
      }
      
      if (!this.redirectUrl) {
        console.warn('Countdown cancelado - no hay URL de redirección');
        return;
      }
      
      this.redirectCountdown = 5;
      
      const countdown = setInterval(() => {
        this.redirectCountdown--;
        console.log(`${this.redirectCountdown} segundos restantes`);
        
        if (this.redirectCountdown <= 0) {
          clearInterval(countdown);
          console.log('Countdown completado, redirigiendo...');
          this.redirectToOriginalPage();
        }
      }, 1000);
      
      this.countdownInterval = countdown;
    },

    // ✅ NUEVO: Cancelar countdown si es necesario
    cancelRedirectCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
        this.redirectCountdown = 0;
        console.log('🛑 [VUE-COUNTDOWN] Countdown cancelado manualmente');
      }
    },

    redirectToOriginalPage() {
      if (this.redirectUrl) {
        console.log('Redirigiendo a:', this.redirectUrl);
        window.location.href = this.redirectUrl;
      } else {
        console.error('No hay URL de redirección disponible');
        window.location.href = this.getDefaultReturnUrl();
      }
    },

    getDefaultReturnUrl() {
      const currentHostname = window.location.hostname;
      let baseUrl;
      
      if (currentHostname.includes('distribuidor.rentik.com')) {
        baseUrl = 'https://www.rentik.com';
        console.log('Entorno PRODUCCIÓN detectado');
      } else if (currentHostname.includes('localhost') || currentHostname.includes('127.0.0.1')) {
        baseUrl = 'https://aem-rentik.projects.orb.local/content/rentik-project';
        console.log('Entorno DESARROLLO detectado');
      } else if (currentHostname.includes('staging') || currentHostname.includes('test')) {
        baseUrl = 'https://staging.rentik.com';
        console.log('Entorno STAGING detectado');
      } else {
        baseUrl = 'https://www.rentik.com';
        console.log('Entorno desconocido, usando PRODUCCIÓN como fallback');
      }
      
      const defaultUrl = `${baseUrl}/es/proceso-compra/compra-finalizada/`;
      console.log('URL por defecto generada:', defaultUrl);
      
      return defaultUrl;
    },

    isProductionEnvironment() {
      const hostname = window.location.hostname;
      return hostname.includes('distribuidor.rentik.com') || hostname.includes('www.rentik.com');
    },

    extractContractIdFromCallback() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        
        // ✅ DEBUG: Mostrar todos los parámetros de URL
        console.log('📋 [DEBUG] Todos los parámetros de URL:', Object.fromEntries(urlParams));
        
        // ✅ PRIORIDAD 1: Buscar session_contract_id (para cross-browser)
        const sessionContractId = urlParams.get('session_contract_id');
        if (sessionContractId) {
          console.log('✅ ContractId encontrado en session_contract_id:', sessionContractId);
          return sessionContractId;
        }
        console.log('❌ session_contract_id no encontrado');
        
        const externalReference = urlParams.get('external_reference');
        
        if (externalReference) {
          // El external_reference suele tener formato como: 333A632D3730323637383835582D523030333838353633
          // donde los últimos caracteres pueden ser el contractId (ejemplo: R00388563)
          console.log('External reference encontrado:', externalReference);
          
          const contractIdMatch = externalReference.match(/R\d{8}/);
          if (contractIdMatch) {
            const extractedContractId = contractIdMatch[0];
            console.log('ContractId extraído de external_reference:', extractedContractId);
            return extractedContractId;
          }
        }
        
        const directContractId = urlParams.get('contractId');
        if (directContractId) {
          console.log('ContractId directo encontrado:', directContractId);
          return directContractId;
        }
        

        const incomeCheckId = urlParams.get('income_check_id');
        const reportsJobId = urlParams.get('reports_generation_job_id');
        
        if (incomeCheckId || reportsJobId) {
          console.log('Intentando extraer de job IDs...');
          

          const storage = sessionStorage;
          const keyPrefix = 'rentik_bankreader_';
          

          for (let i = 0; i < storage.length; i++) {
            const key = storage.key(i);
            if (key && key.startsWith(keyPrefix) && key.includes('contractId')) {
              const potentialContractId = key.replace(keyPrefix, '').replace('_contractId', '');
              if (potentialContractId.match(/R\d{8}/)) {
                console.log('ContractId encontrado en storage:', potentialContractId);
                return potentialContractId;
              }
            }
          }
        }
        
        console.warn('No se pudo extraer contractId de ninguna fuente');
        return null;
        
      } catch (error) {
        console.error('Error extrayendo contractId:', error);
        return null;
      }
    },


    goToDefaultPage() {
      console.log('Redirigiendo a página por defecto');
      const defaultUrl = this.getDefaultReturnUrl();
      window.location.href = defaultUrl;
    },


    handleBankReaderError(errorType, errorReason, errorMessage) {
      console.log('Analizando error de Bank Reader:', {
        type: errorType,
        reason: errorReason,
        message: errorMessage
      });
      
      this.loading = false;
      
      if (errorType === 'USER_CANCELLED' || errorReason === 'USER_CANCELLED') {
        console.log('Usuario canceló el proceso de Bank Reader');
        
        this.title = 'Proceso cancelado';
        this.message = 'Has cancelado la verificación bancaria. Puedes intentarlo nuevamente cuando quieras.';
        this.iconName = 'hi-x-circle';
        
        this.generateReturnUrlForCancellation();
        this.showCancellationOptions();
        
      } else if (errorType === 'TECHNICAL_ERROR' || errorType === 'SYSTEM_ERROR') {
        console.log('Error técnico del sistema');
        
        this.title = 'Error técnico';
        this.message = 'Ha ocurrido un error técnico en el sistema. Por favor, inténtalo nuevamente en unos minutos.';
        this.iconName = 'hi-x-circle';
        
        this.generateReturnUrlForError();
        this.showManualRedirectOption();
        
      } else if (errorType === 'TIMEOUT' || errorMessage?.includes('timeout')) {
        console.log('Timeout en el proceso');
        
        this.title = 'Tiempo agotado';
        this.message = 'El tiempo para completar la verificación ha expirado. Puedes intentarlo nuevamente.';
        this.iconName = 'hi-x-circle';
        
        this.generateReturnUrlForError();
        this.showManualRedirectOption();
        
      } else {
        console.log('Error genérico o desconocido');
        
        this.title = 'Ha ocurrido un error';
        this.message = errorMessage ? decodeURIComponent(errorMessage) : 'Por favor vuelve a intentarlo más tarde.';
        this.iconName = 'hi-x-circle';
        
        this.generateReturnUrlForError();
        this.showManualRedirectOption();
      }
    },


    generateReturnUrlForCancellation() {
      if (!this.sessionData) {
        console.warn('No hay datos de sesión para cancelación');
        this.redirectUrl = this.getDefaultReturnUrl();
        return;
      }
      
      try {
        const originalUrl = new URL(this.sessionData.originalUrl);
        const baseUrl = originalUrl.origin + originalUrl.pathname;
        
        const returnUrl = new URL(baseUrl);
        returnUrl.searchParams.set('contractId', this.sessionData.contractId);
        
        // Solo agregar accessKey si tenemos uno válido
        if (this.sessionData.accessKey && this.sessionData.accessKey !== 'RECOVERED_FROM_CALLBACK') {
          returnUrl.searchParams.set('accessKey', this.sessionData.accessKey);
        }
        
        returnUrl.searchParams.set('bank_reader_status', 'cancelled');
        
        this.redirectUrl = returnUrl.toString();
        console.log('URL de retorno para cancelación generada:', this.redirectUrl);
        
      } catch (error) {
        console.error('Error generando URL de cancelación:', error);
        this.redirectUrl = this.sessionData.originalUrl;
      }
    },


    showCancellationOptions() {
      console.log('Mostrando opciones de cancelación');
      
      this.message += ' El proceso de tu contrato no se ha visto afectado.';
      
      this.redirectCountdown = 0;
    }
  },
};
</script>

<style scoped lang="scss">


.header {
  width: 100%;
  height: 100%;
  background-color: #000;

  .white-logo {
    padding: 12px 50px;
  }
}


</style>